import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { LogOut, Users } from 'lucide-react';
import { MyShowLogoNeon } from '@/components/Logo';
import { Button } from '@/components/ui/Button';
import { apiClient } from '@/services/api';
import { useAuthStore } from '@/stores/authStore';

export function PartnerLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const signOut = useAuthStore(s => s.signOut);

  const { data: me } = useQuery({
    queryKey: ['partner-me'],
    queryFn: () => apiClient.partner.me().then(r => r.data),
  });

  async function onLogout() {
    await signOut();
    navigate('/login');
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="container-app flex items-center justify-between py-3">
          <Link to="/parceiro" className="flex items-center gap-3">
            <MyShowLogoNeon height={36} />
            <span className="rounded-full bg-brand-600/10 px-2.5 py-0.5 text-xs font-semibold text-brand-700">
              Parceiro
            </span>
          </Link>
          <div className="flex items-center gap-4">
            {me && (
              <div className="text-right hidden sm:block">
                <div className="text-sm font-medium leading-tight">{me.name}</div>
                <div className="text-xs text-muted-foreground">{me.client_count} cliente(s)</div>
              </div>
            )}
            <Button size="sm" variant="ghost" onClick={onLogout} title="Sair">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>

      <nav className="border-b border-border bg-card/50">
        <div className="container-app flex gap-1 py-2">
          <Link
            to="/parceiro"
            className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium ${
              pathname === '/parceiro' ? 'bg-brand-600/10 text-brand-700' : 'text-muted-foreground hover:bg-muted'
            }`}
          >
            <Users className="h-4 w-4" /> Meus clientes
          </Link>
        </div>
      </nav>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
